import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { authApi } from '../../api/services';
import toast from 'react-hot-toast';
export default function LoginPage() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authApi.login({ phone, password });
      setAuth({ userId: res.data.userId, role: res.data.role, accessToken: res.data.accessToken, refreshToken: res.data.refreshToken });
      toast.success('Giriş başarılı!');
      if (res.data.role === 'Admin' || res.data.role === 'Operator') navigate('/admin');
      else navigate('/');
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Giriş başarısız');
    } finally { setLoading(false); }
  };
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',padding:'24px'}}>
      <div className='card' style={{width:'100%',maxWidth:'400px',padding:'40px'}}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:'16px'}}>
          <Link to='/'>
            <img src='/logo-transparent.png' alt='Zavadak' style={{height:'44px',maxWidth:'220px',objectFit:'contain'}} />
          </Link>
        </div>
        <p className='text-muted text-center' style={{marginBottom:'28px'}}>Hesabınıza giriş yapın</p>
        <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:'16px'}}>
          <div className='form-group'>
            <label className='form-label'>Telefon</label>
            <input className='form-input' type='tel' value={phone} onChange={e=>setPhone(e.target.value)} placeholder='05xxxxxxxxx' required />
          </div>
          <div className='form-group'>
            <label className='form-label'>Şifre</label>
            <input className='form-input' type='password' value={password} onChange={e=>setPassword(e.target.value)} placeholder='••••••' required />
          </div>
          <button className='btn btn-primary btn-full btn-lg' type='submit' disabled={loading}>{loading ? '...' : 'Giriş Yap'}</button>
        </form>
        <p className='text-center text-muted' style={{marginTop:'24px',fontSize:'0.9rem'}}>Hesabınız yok mu? <Link to='/register' style={{color:'var(--color-primary)'}}>Kayıt Ol</Link></p>
      </div>
    </div>
  );
}
